import { useOverlayContext, useStoreActions } from '~/contexts';
import { handleRequest } from '~/infra/utils';
const unmarkPaidExternallyLoader = (invoiceId)=>"unmarkPaidExternally-".concat(invoiceId);
export function useUnmarkPaidExternally() {
    const { api } = useStoreActions();
    const { startLoader, stopLoader, showErrorToast } = useOverlayContext();
    return {
        async startUnmarkPaidExternally (invoice) {
            startLoader(unmarkPaidExternallyLoader(invoice.id));
            const result = await handleRequest(api.invoice.unmarkAsPaidExternally(invoice.id));
            if (result.success) {
            // Here we wait for a pusher event to stop the loader and update the invoice.
            } else {
                showErrorToast(result.error.unmarkPaidExternallyErrorText(invoice), 'fpi-unmark-paid-externally-error');
                stopLoader(unmarkPaidExternallyLoader(invoice.id));
            }
        },
        async finishUnmarkPaidExternally (invoiceId) {
            stopLoader(unmarkPaidExternallyLoader(invoiceId));
        }
    };
}
